import { Dtos, SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../utils/request";
import { accountLatestIndemnityAgreementQueryKey } from "./account.keys";

export const useFetchAccountLatestIndemnityAgreement = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const { data, error, isLoading, refetch } = useQuery({
		queryKey: accountLatestIndemnityAgreementQueryKey(accountId),
		queryFn: () =>
			get<Dtos.SuretyAccount.IndemnityAgreement.Get.Response | null>(
				`/v2/surety/accounts/${accountId}/indemnity-agreements/latest`,
			),
	});

	return {
		latestIndemnityAgreement: data,
		latestIndemnityAgreementError: error,
		latestIndemnityAgreementIsLoading: isLoading,
		refetchLatestIndemnityAgreement: refetch,
	};
};
